<script setup lang="ts"></script>

<template>
  <label :class="$style.label">
    <p :class="$style.label__title"><slot name="title" /></p>
    <div :class="$style.label__input">
      <slot />
    </div>
  </label>
</template>

<style lang="scss" module>
.label {
  &__title {
    font-size: 12px;
    font-weight: bold;
  }

  &__input {
    margin-top: 8px;

    & > * {
      width: 100%;
    }
  }
}
</style>
